import { useContext, useEffect, useState } from 'react';
import { useFieldArray, useForm, useFormContext } from 'react-hook-form';
import { FormControl, FormField, FormLabel, FormItem, FormMessage, } from '@/components/shadcn/ui/form';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/ui/popover';
import {
  Command, CommandInput, CommandGroup,
  CommandEmpty, CommandItem, CommandList
} from '@/components/shadcn/ui/command';
import { Textarea } from '@/components/shadcn/ui/textarea';
import { InputMasks } from '@/components/shadcn/ui/input';
import { Calendar } from '@/components/shadcn/ui/calendar';
import { Button } from '@/components/shadcn/ui/button';
import { CalendarIcon, Check, ChevronsUpDown, Contact } from 'lucide-react';
import { ptBR } from 'date-fns/locale';
import { format } from 'date-fns';
import { cn } from '@/lib/utils';
import { useSourceContext } from '@/pages/configurations/source/SourceContext';
import { MentionsInput, Mention } from 'react-mentions';
import mentionStyles from './mentionStyles';

import { useBusinessDetailContext } from '@/context/BusinessDetailContext';
import { toast, useToast } from '@/components/shadcn/ui/use-toast';
import { useClients } from '@/hook/useClients';
import { useBusinessSource } from '@/hook/useBusinessSource';
import { useActivityType } from '@/hook/useActivityType';
import { useBusiness } from '@/hook/useBusiness';
import { useNavigate, useParams } from 'react-router-dom';
import { BusinessUpdateInterface } from '@/entities/business';
import { useIndicators } from '@/hook/useIndicators';
import { useAuthContext } from '@/context/AuthContext';
import React from 'react';
import { CreateClient } from '@/entities/clients';
import MaskRemover from '@/utils/removeMask';
import { useActivityBranch } from '@/hook/useActivityBranch';
import { BusinessService } from '@/services/BusinessService';
import { useBusinessIndicator } from '@/hook/useBusinessIndicator';
interface ClientForm {
  id: number;
  fantasyName: string;
}

interface TypeForm {
  id: number;
  name: string;
}

interface SourceType {
  id: number,
  description: string
}

interface IndicatorForm {
  id: number,
  name: string
}
const InfoCliente = () => {
  // const { sources, addSource } = useSourceContext();
  const { control, getValues, setValue, handleSubmit } = useFormContext();
  const navigate = useNavigate()
  const [isCpf, setIsCpf] = useState(true);
  const { clientsUse, createClient } = useClients();
  const { businessSources } = useBusinessSource();
  const { indicators } = useIndicators();
  const { activityTypes } = useActivityType();
  const { activityBranchs } = useActivityBranch();
  const [sources, setSources] = useState<SourceType[]>([]);
  const [clients, setFormClient] = useState<ClientForm[]>([]);
  const [types, setFormTypes] = useState<TypeForm[]>([]);
  const [indicadores, setIndicatorsForm] = useState<IndicatorForm[]>([]);
  const { business, businessEdit, setBusinessEdit, businessEdit2, setBusinessEdit2, fetchbusinessById, setbusiness } = useBusinessDetailContext();
  const [getBusiness, setGetBusiness] = useState<any>();
  const [indicatorId, setIndicatorId] = useState<any>(0);
  const [openDtInicio, setOpenDtInicio] = useState(false);
  const [openPrevision, setOpenPrevision] = useState(false);
  const [openTypeSelect, setOpenTypeSelect] = useState(false);
  const [openTypeSelectI, setOpenTypeSelectI] = useState(false);
  const [hasClient, setHasCliente] = useState(false);
  const companyId = Number(localStorage.getItem("companyId"));
  const [cpfcnpj, setCpfcnpj] = useState('');
  // const [ businessId, setBId] = useState(0);
  const { toast } = useToast();
  const { leadId } = useParams<{ leadId: string }>();
  const leadId2Set = Number(leadId);
  const { business2 } = useBusiness(leadId2Set);
  const { createBusinessIndicator, updateBusinessIndicatorId } = useBusinessIndicator();
  const [openClientSelect, setOpenClientSelect] = useState(false);
  const [openIndicatorSelect, setOpenIndicatorSelect] = useState(false);
  const { accessToken } = useAuthContext();

  const clientsAdd = clientsUse.map((client) => ({
    id: client.id,
    fantasyName: client.fantasyName,
  }));

  const typesAdd = activityTypes.map((type) => ({
    id: type.id,
    name: type.name,
  }));

  const sourceAdd = businessSources.map((source) => ({
    id: source.id,
    description: source.description
  }));

  const indicatorsAdd = indicators.map((indicator) => ({
    id: indicator.id,
    name: indicator.name
  }));

  const handleMaskChange = (type: string) => {
    setIsCpf(type === "cpf");
    const newValue = ""; // Reset input ao trocar
    setCpfcnpj(newValue);
    setValue("cpfcnpj", newValue);
    setBusinessEdit2({ ...getValues() });
  };

  const values = getValues();

  useEffect(() => {
    if (!businessEdit2) return;
    setGetBusiness(business);
    setFormClient(clientsAdd);
    setFormTypes(typesAdd);
    setSources(sourceAdd);
    setIndicatorsForm(indicatorsAdd);
    setValue('descricao', businessEdit2.descricao);
    setValue('idnegocio', businessEdit2.idnegocio);
    setValue('observacao', `${businessEdit2.observacao}`);
    setValue('email', businessEdit2.email)
    setValue('tel', businessEdit2.tel)
    if (businessEdit2?.indicators?.length > 0) {
      setValue('indicador', businessEdit2.indicators?.[0]?.indicator?.indicatorId ?? '');
    }
    if (businessEdit2.client?.id) {
      setHasCliente(true);
      setValue('cpfcnpj', businessEdit2.client?.cpfCnpj);
      setValue('fantasia', businessEdit2.client?.fantasyName);
      setValue('razao', businessEdit2.client?.corporateName);
      setValue('responsible', businessEdit2.client?.responsible);
      setValue('atividade', businessEdit2.client?.activityBranchID);
    }
  }, [businessEdit2]);

  const onSubmit = async (data: any) => {

    const formValues = getValues();
    if (!formValues.fantasia?.trim()) {
      toast({ description: "Preencha o campo Nome Fantasia" });
      return;
    }

    if (!formValues.razao?.trim()) {
      toast({ description: "Preencha o campo Razão Social" });
      return;
    }


    if (hasClient) {
      toast({ description: "Este negócio já tem um cliente vinculado!\nPara alterar informações do cliente vá até\nNegócios->Cliente" });
      return;
    }

    const updateData: CreateClient = {
      corporateName: data.razao,
      fantasyName: data.fantasia,
      responsible: data.responsible,
      cpfCnpj: data.cpfcnpj,
      status: 'A',
      companyId: companyId,
      activityBranchId: data.atividade,
      contact: {
        name: data.responsible,
        email: data.email,
        cellPhone: data.tel,
      }
    };

    const result = await createClient(updateData);

    if (result) {
      await BusinessService.updateBusiness(businessEdit2.idnegocio, { clientId: result.id });
      toast({ description: "Cliente Adicionado e vinculado com sucesso!" });
    } else {
      toast({ description: "Ocorreu um erro! Dados não foram salvos.", variant: "destructive" });
    }
  };

  {/*console.log(getBusiness);*/ return (
    <div className='flex bg-indigo-200 py-0 justify-center w-screen max-h-max'>
      {/** Descrição */}
      <form className='flex py-2 px-2 w-[90%] h-auto max-h-max h-auto bg-white rounded-xl flex-col gap-4' onSubmit={handleSubmit(onSubmit)}>
        <div className='flex items-start justify-center gap-4'>
          <FormField
            control={control}
            name="descricao"
            rules={{ required: "Preencha o campo" }}
            render={({ field }) => (
              <FormItem className='flex flex-col w-1/2'>
                <FormLabel className='text-slate-900 pb-2.5'>Negócio: </FormLabel>
                <FormControl>
                  <InputMasks
                    placeholder="Negócio: "
                    className="resize-none text-muted-foreground bg-slate-50 hover:bg-slate-100 hover:placeholder:text-slate-900 hover:text-slate-900 focus:bg-white"
                    {...field}
                    onChange={(e: { target: { value: any; }; }) => {
                      // Atualizando o valor no formulário
                      setValue('descricao', e.target.value);
                      setBusinessEdit2(getValues());
                    }}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name="atividade"
            rules={{ required: "Preencha o campo" }}
            render={({ field }) => (
              <FormItem className='flex flex-col w-1/2'>
                <FormLabel className='text-slate-900 pb-2.5'>Atividade :</FormLabel>
                <Popover open={openClientSelect} onOpenChange={setOpenClientSelect}>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button

                        aria-expanded={openTypeSelect}
                        variant='outline'
                        role='combobox'
                        className={cn('w-full h-10 justify-between bg-slate-50 focus:bg-white text-muted-foreground font-normal',
                          !field.value && 'text-muted-foreground font-normal'
                        )}>
                        {field.value
                          ? activityBranchs.find(
                            (client) => client.id === field.value
                          )?.name
                          : 'Selecione o ramo de atividade'
                        }
                        <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className='w-inherit p-0'>
                    <Command>
                      <CommandInput placeholder={business ? activityBranchs.find((c) => c.id === business.clientId)?.name : 'Procure uma atividade'} />
                      <CommandEmpty>Não encontrado</CommandEmpty>
                      <CommandList>
                        <CommandGroup>
                          {activityBranchs.map((client) => (
                            <CommandItem
                              value={client.name}
                              key={client.id}
                              onSelect={() => {
                                setValue('atividade', client.id);
                                setOpenClientSelect(false);
                                setBusinessEdit(getValues());
                              }}
                            >
                              <Check
                                className={cn('mr-2 h-4 w-4',
                                  client.id === field.value
                                    ? 'opacity-100'
                                    : 'opacity-0'
                                )}
                              />
                              <span>{client.name}</span>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
              </FormItem>
            )}
          />
        </div>
        {/** tipo negocio */}
        <div className='flex items-center justify-start gap-4'>
          <FormField
            control={control}
            name='razao'
            rules={{ required: "Preencha o campo" }}
            render={({ field }) => (
              <FormItem className='flex flex-col w-1/2'>
                <FormLabel className='text-slate-900 pb-2.5'>Razão Social: </FormLabel>
                <FormControl>
                  <InputMasks
                    {...field}
                    className='bg-slate-50 text-muted-foreground hover:bg-slate-100 hover:text-slate-900 focus:bg-white'
                    placeholder="Digite a razão social da sua empresa: "
                    onChange={(e: any) => {
                      const newValue = e.target.value.toString().toUpperCase();
                      // console.log(newValue);

                      // Atualiza o valor no formulário e no estado
                      field.onChange(newValue);
                      setValue('razao', newValue);

                      // Atualiza o estado de businessEdit2 com os novos valores
                      setBusinessEdit2({
                        ...getValues(),  // Obtém os valores mais recentes do formulário
                      });
                      // console.log(businessEdit2);
                      // Caso você precise do businessEdit2 atualizado em tempo real, use um useEffect para monitorar
                    }}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name='fantasia'
            rules={{ required: "Preencha o campo" }}
            render={({ field }) => (
              <FormItem className='flex flex-col w-1/2'>
                <FormLabel className='text-slate-900 pb-2.5'>Nome Fantasia: </FormLabel>
                <FormControl>
                  <InputMasks
                    {...field}
                    className='bg-slate-50 text-muted-foreground hover:bg-slate-100 hover:text-slate-900 focus:bg-white'
                    placeholder="Digite o nome fantasia da sua empresa: "
                    onChange={(e: any) => {
                      const newValue = e.target.value.toString().toUpperCase();
                      // console.log(newValue);

                      // Atualiza o valor no formulário e no estado
                      field.onChange(newValue);
                      setValue('fantasia', newValue);

                      // Atualiza o estado de businessEdit2 com os novos valores
                      setBusinessEdit2({
                        ...getValues(),  // Obtém os valores mais recentes do formulário
                      });
                      // console.log(businessEdit2);
                      // Caso você precise do businessEdit2 atualizado em tempo real, use um useEffect para monitorar
                    }}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        {/** Cliente */}
        <div className='flex items-center justify-start gap-4'>
          {/** Número do telefone */}
          <FormField
            control={control}
            rules={{ required: "Preencha o campo" }}
            name="cpfcnpj"
            render={({ field }) => (
              <FormItem className="flex flex-col w-1/2">
                <div className="flex space-x-2 mb-2">
                  <Button
                    variant={isCpf ? "default" : "outline"}
                    onClick={() => handleMaskChange("cpf")}
                  >
                    CPF
                  </Button>
                  <Button
                    variant={!isCpf ? "default" : "outline"}
                    onClick={() => handleMaskChange("cnpj")}
                  >
                    CNPJ
                  </Button>
                </div>
                <FormControl>
                  <InputMasks
                    {...field}
                    className="bg-slate-50 text-muted-foreground hover:bg-slate-100 hover:text-slate-900 focus:bg-white"
                    mask={isCpf ? "999.999.999-99" : "99.999.999/9999-99"}
                    maskChar=""
                    placeholder={isCpf ? "CPF" : "CNPJ"}
                    onChange={(e: { target: { value: any; }; }) => {
                      const newValue = e.target.value;
                      field.onChange(newValue);
                      setCpfcnpj(newValue);
                      setValue("cpfcnpj", newValue);
                      setBusinessEdit2({ ...getValues() });
                    }}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={control}
            rules={{ required: "Preencha o campo" }}
            name='responsible'
            render={({ field }) => (
              <FormItem className='flex flex-col w-1/2'>
                <FormLabel className='text-slate-900 pb-2.5'>Responsável pela empresa: </FormLabel>
                <FormControl>
                  <InputMasks
                    {...field}
                    className='bg-slate-50 text-muted-foreground hover:bg-slate-100 hover:text-slate-900 focus:bg-white'
                    placeholder="Digite o nome do responsável pela empresa:"
                    onChange={(e: any) => {
                      const newValue = e.target.value.toString().toUpperCase();
                      // console.log(newValue);

                      // Atualiza o valor no formulário e no estado
                      field.onChange(newValue);
                      setValue('responsible', newValue);

                      // Atualiza o estado de businessEdit2 com os novos valores
                      setBusinessEdit2({
                        ...getValues(),  // Obtém os valores mais recentes do formulário
                      });
                      // console.log(businessEdit2);
                      // Caso você precise do businessEdit2 atualizado em tempo real, use um useEffect para monitorar
                    }}
                  />
                </FormControl>
              </FormItem>
            )}
          />

        </div>
        <div className='flex items-center justify-start gap-4'>
          <FormField
            control={control}
            name="indicador"
            rules={{ required: "Preencha o campo" }}
            render={({ field }) => (
              <FormItem className='flex flex-col w-1/2'>
                <FormLabel className='text-slate-900 pb-2.5'>Indicador: </FormLabel>
                <Popover open={openIndicatorSelect} onOpenChange={setOpenIndicatorSelect}>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button

                        aria-expanded={openTypeSelectI}
                        variant='outline'
                        role='combobox'
                        className={cn('w-full h-10 justify-between bg-slate-50 focus:bg-white text-muted-foreground font-normal',
                          !field.value && 'text-muted-foreground font-normal'
                        )}>
                        {field.value
                          ? indicators.find(
                            (client) => client.id === field.value
                          )?.name
                          : 'Selecione um Indicador'
                        }
                        <ChevronsUpDown className='ml-2 h-4 w-4 shrink-0 opacity-50' />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className='w-inherit p-0'>
                    <Command>
                      <CommandInput placeholder={business ? indicators.find((c) => c.id === business.clientId)?.name : 'Adicione um Indicador: '} />
                      <CommandEmpty>Não encontrado</CommandEmpty>
                      <CommandList>
                        <CommandGroup>
                          {indicators.map((client) => (
                            <CommandItem
                              value={client.name}
                              key={client.id}
                              onSelect={() => {

                                setValue('indicador', client.id);
                                setIndicatorId(client.id);
                                setOpenIndicatorSelect(false);
                                setBusinessEdit(getValues());
                                updateBusinessIndicatorId(leadId2Set, client.id);
                                toast({ description: 'indicador atualizado com sucesso!' });
                              }}
                            >
                              <Check
                                className={cn('mr-2 h-4 w-4',
                                  client.id === field.value
                                    ? 'opacity-100'
                                    : 'opacity-0'
                                )}
                              />

                              <span>{client.name}</span>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
              </FormItem>
            )}
          />
          <FormField
            control={control}
            rules={{ required: "Preencha o campo" }}
            name='observacao'
            render={({ field }) => (
              <FormItem className='flex flex-col w-1/2'>
                <FormLabel className='text-slate-900 pb-2.5'>Comentario :</FormLabel>
                <FormControl>
                  <Textarea
                    {...field}
                    className='bg-slate-50 text-muted-foreground hover:bg-slate-100 hover:text-slate-900 focus:bg-white'
                    onChange={(e: any) => {
                      const newValue = e.target.value;
                      // console.log(newValue);

                      // Atualiza o valor no formulário e no estado
                      field.onChange(newValue);
                      setValue('observacao', newValue);

                      // Atualiza o estado de businessEdit2 com os novos valores
                      setBusinessEdit2({
                        ...getValues(),  // Obtém os valores mais recentes do formulário
                      });
                      // console.log(businessEdit2);
                      // Caso você precise do businessEdit2 atualizado em tempo real, use um useEffect para monitorar
                    }}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
        <div className='grid grid-rows-2 grid-cols-2 gap-4 w-[100%]'>
          <Button
            onClick={(e) => {
              onSubmit(businessEdit2);
            }} type='submit' variant='outline' className=" text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Salvar informações de cliente</Button>
          <Button
            onClick={(e) => {
              navigate(`/levantamento/${leadId}?tab=necessidades`);
              location.reload();
            }} type='submit' variant='outline' className=" text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Ir para levantamento de necessidades</Button>
        </div>
      </form>
    </div>
  );
  }
};

export default InfoCliente;
